export enum Forms {
  ingredientFilterForm = 'ingredientFilterForm',
  ingredientCreationForm = 'ingredientCreationForm',
  ingredientRenameForm = 'ingredientRenameForm',
  ingredientInventoryAddAmountForm = 'ingredientInventoryAddAmountForm',
  ingredientInventoryEdit = 'ingredientInventoryEdit',

  ingredientGraph = 'ingredientGraph',

  inventorySettings = 'inventorySettings',

  advancedSettings = 'advancedSettings',

  orderCreationForm = 'orderCreationForm',

  premixesFilterForm = 'premixesFilterForm',
  premixCreationForm = 'premixCreationForm',
  premixRenameForm = 'premixRenameForm',
  premixIngredientsForm = 'premixIngredientsForm',

  projectedRequirementsForm = 'projectedRequirementsForm',

  recipesFilterForm = 'recipesFilterForm',
  recipeForm = 'recipeForm',
  recipeRenameForm = 'recipeRenameForm',
  recipeDuplicateForm = 'recipeDuplicateForm',
  recipeAddTransitionDay = 'recipeAddTransitionDay',
  recipeIngredientsForm = 'recipeIngredientsForm',

  groupsFilterForm = 'groupsFilterForm',
  groupCreationForm = 'groupCreationForm',
  groupEditForm = 'groupEditForm',
  groupEditDaysOnRationForm = 'groupEditDaysOnRationForm',
  groupEditFullForm = 'groupEditFullForm',
  groupTypeCreationForm = 'groupTypeCreationForm',
  feedingCreationForm = 'feedingCreationForm',
  feedingListForm = 'feedingListForm',
  feedingEditRecipeForm = 'feedingEditRecipeForm',
  feedingListTableForm = 'feedingListTableForm',
  bunkReaderDateRange = 'bunkReaderDateRange',

  loadMixersForm = 'loadMixersForm',
  mixersFilterForm = 'mixersFilterForm',
  mixersEditForm = 'mixersEditForm',
  mixerCreationForm = 'mixerCreationForm',
  scheduledPremixInFeeding = 'scheduledPremixInFeeding',

  companyUserNew = 'companyUserNew',

  zoneForm = 'zoneForm',
  zonesSearch = 'zonesSearch',

  searchPartner = 'searchPartner',
  sharing = 'sharing',
  editInvitation = 'editInvitation',
  leaveInvitation = 'leaveInvitation',

  feedingListSearch = 'feedingListSearch',

  operatorsSearch = 'operatorsSearch',
  operatorsForm = 'operatorsForm',

  // Reports
  reportsToolbarSearchGroups = 'reportsToolbarSearchGroups',
  reportsPresetsForm = 'reportsPresetsForm',
  reportsPageForm = 'reportsPageForm',
  reportsSpecificPageForm = 'reportsSpecificPageForm',
  collapsibleCardsForm = 'collapsibleCardsForm',
  reportSettingsForm = 'reportSettingsForm',
  scheduleEmailForm = 'scheduleEmailForm',

  stocktransactionItemReceive = 'stocktransactionItemReceive',

  // Shared
  nameInput = 'nameInput',

  settingsForm = 'settingsForm',
  driverChanges = 'driverChanges',
  agentSettings = 'agentSettings',
  loadsProgramming = 'loadsProgramming',
  penTypesSearch = 'penTypesSearch',
  datalinkSettings = 'datalinkSettings',
  otherSettings = 'otherSettings',
  weighBridgeSystem = 'weighBridgeSystem',
  thirdPartyIntegration = 'thirdPartyIntegration',
  externalFeedingSystem = 'externalFeedingSystem',
  operatorsManagement = 'operatorsManagement',
  operatorsPermissions = 'operatorsPermissions',
  locationsSearch = 'locationsSearch',
  binControl = 'binControl',

  feedingPeriodNameForm = 'feedingPeriodNameForm',
  feedingPeriod = 'feedingPeriod',
  createFeedingPeriod = 'createFeedingPeriod',

  mixerCommandsForm = 'mixerCommandsForm',

  dataToolsPageForm = 'dataToolsPageForm',
  dataToolsSearchForm = 'dataToolsSearchForm',
  dataToolsSpecificPageToolbarForm = 'dataToolsSpecificPageToolbarForm',
  dataToolsSpecificContentFrom = 'dataToolsSpecificContentFrom',

  refusalsSearchForm = 'refusalsSearchForm',
  refusalsSettingsForm = 'refusalsSettingsForm',
  refusalsToolbarForm = 'refusalsToolbarForm',

  lotsFilterForm = 'lotsFilterForm',
  lotsEditorForm = 'lotsEditorForm',

  relationSearchForm = 'relationSearchForm',
  relationCreationForm = 'relationCreationForm',

  lotTypeCreationForm = 'lotTypeCreationForm',
  lotMarketTypeSearchForm = 'lotMarketTypeSearchForm',
  lotTypesSearchForm = 'lotTypesSearchForm',
  costTypesCreationForm = 'costTypesCreationForm',
  costTypesSearchForm = 'costTypesSearchForm',
  costTypesEditorForm = 'costTypesEditorForm',
  costSummaryReport = 'costSummaryReport',

  herdManagementSystemForm = 'herdManagementSystemForm',
  closeoutPreviewOptionsForm = 'closeoutPreviewOptionsForm',

  stockTransactionSettingsForm = 'stockTransactionSettingsForm',

  archiveTicketsFilterForm = 'archiveTicketsFilterForm',
}

export interface SearchFormFields {
  search: string;
}
